import { generatePath } from "ui-kit";

export const paths = {
  listAll: "/invites",
  list: "/:groupId/invites",
  create: "/:groupId/invites/create",
  view: "/:groupId/invites/:inviteId",
};

export const generators = {
  listAll: () => generatePath(paths.listAll),
  list: ({ groupId }: Record<"groupId", string>) =>
    generatePath(paths.list, { groupId }),
  create: ({ groupId }: Record<"groupId", string>) =>
    generatePath(paths.create, { groupId }),
  view: ({ groupId, inviteId }: Record<"groupId" | "inviteId", string>) =>
    generatePath(paths.view, { groupId, inviteId }),
};
